<template>
    <div>
        <b-overlay :show="loading" rounded="sm">
            <div v-if="recoveryform">
            <b-alert :show="loginAlert" variant="warning">{{loginAlertMsg}}</b-alert>
                Ingrese el código de recuperación que se le envió al correo.
                <div>{{ name }}</div>
                <b-form-input :state="recoverystate" class="my-2" v-model="recoverycode" placeholder="Código de recuperación" type="text"></b-form-input>
                <b-form-input :state="passwordstate" class="mb-2" v-model="password" placeholder="Nueva contraseña" type="password"></b-form-input>
                
                <div class="text-center mb-3">
                    <b-button variant="success" @click="setRecover()">Cambiar contraseña</b-button>
                    <b-button class="ml-2" @click="recoveryform = false">Cancelar</b-button>
                </div>
            </div>
            <b-tabs content-class="mt-3" fill v-else>
                <b-tab title="Entrar" active>
                    <b-alert :show="loginAlert" variant="warning">{{loginAlertMsg}}</b-alert>
                    Ya tengo cuenta
                    <b-form-input :state="namestate" class="my-2" v-model="name" placeholder="Correo electrónico" type="email"></b-form-input>
                    <b-form-input :state="passwordstate" class="mb-2" v-model="password" placeholder="Contraseña" type="password"></b-form-input>
                    <div class="mb-3 text-right">
                        <b-button variant="link" style="font-size: small; font-family: 'Nunito Sans';" @click="passwordrecovery();">
                            Olvidé mi contraseña
                        </b-button>
                    </div>
                    <div class="text-center mb-3">
                        <b-button variant="success" @click="login(1);">Entrar</b-button>
                        <b-button class="ml-2" @click="cancelar();">Cancelar</b-button>
                    </div>
                </b-tab>
                <b-tab title="Registrarse">
                    <b-alert :show="registerAlert" variant="warning">{{registerAlertMsg}}</b-alert>
                    No tengo cuenta
                    <b-form-input :state="firstnamestate" class="my-2" v-model="firstname" placeholder="Nombre"></b-form-input>
                    <b-form-input :state="lastnamestate" class="mb-2" v-model="lastname" placeholder="Apellido"></b-form-input>
                    <b-form-input :state="namestate" class="mb-2" v-model="name" placeholder="Correo electrónico" type="email"></b-form-input>
                    <b-form-input :state="passwordstate" class="mb-2" v-model="password" placeholder="Contraseña" type="password"></b-form-input>
                    <div class="text-center mb-3">
                        <b-button variant="success" @click="login(2);">Registrarse</b-button>
                        <b-button class="ml-2" @click="cancelar();">Cancelar</b-button>
                    </div>
                </b-tab>
            </b-tabs>
        </b-overlay>
    </div>
</template>
<script>
import axios from "axios";

export default {
     data(){
        return {
            name: '',
            password: '',
            namestate: null,
            passwordstate: null,
            loginAlert: false,
            loginAlertMsg: '',
            registerAlert: false,
            registerAlertMsg: '',
            firstnamestate: null,
            lastnamestate: null,
            firstname: '',
            lastname: '',
            recoveryform: false,
            recoverycode: '',
            recoverystate: null,
            loading: false
        }
    },
    methods:{
        async login(type){
            if (type === 2){
                if (this.firstname === ''){
                    this.firstnamestate = false;
                    return;
                }else{
                    this.firstnamestate = true;
                }
                if (this.lastname === ''){
                    this.lastnamestate = false;
                    return;
                }else{
                    this.lastnamestate = true;
                }
            }
            if (this.name === '' || !this.name.includes('@')){
                this.namestate = false;
                return;
            }else{
                this.namestate = true;
            }
            if (this.password === ''){
                this.passwordstate = false;
                return;
            }else{
                this.passwordstate = true;
            }
            
            let method = '';
            if(type === 1){
                method = 'login';
            }else{
                method = 'create';
            }

            this.loading = true;
            await axios
                .post(
                this.$store.state.user.siteData.location + "clients/clients/"+method,
                JSON.stringify({name: this.name, password: this.password, firstname: this.firstname, lastname: this.lastname}),
                {
                    validateStatus(status) {
                    return status < 500; // Resolve only if the status code is less than 500
                    },
                    headers: {
                    "Content-Type": "application/json"
                    }
                }
                )
                .then(evtResponse => {
                    console.log(evtResponse.data);
                    this.loading = false;
                    if (evtResponse.data.result === 0){
                        if (type === 1){
                            this.loginAlert = true;
                            if (evtResponse.data.errorcode === 1){
                                this.loginAlertMsg = 'El usuario no existe';
                            }else if (evtResponse.data.errorcode === 2){
                                this.loginAlertMsg = 'La contraseña ingresada es incorrecta';
                            }
                        }else{
                            this.registerAlert = true;
                            if (evtResponse.data.errorcode === 6){
                                this.registerAlertMsg = 'La casilla de mail ya está en uso';
                            }
                        }
                    }else{
                        this.$store.dispatch('LogIn',evtResponse.data.data);
                        this.$emit('login', evtResponse.data.data);
                    }  
                })
                .catch(()=>{
                    this.loading = false;
                });
        },
        cancelar(){
            this.$emit('cancel', null);
        },
        async passwordrecovery(){
            if (this.name === ''){
              this.loginAlert = true;
              this.loginAlertMsg = 'Escriba su dirección de correo para recuperar su contraseña'
              return
            }
                        
            this.loginAlert = false;
            this.loading = true;

            await axios
                .post(
                this.$store.state.user.siteData.location + "clients/clients/generateRecoveryCode",
                JSON.stringify({mail: this.name}),
                {
                    validateStatus(status) {
                    return status < 500; // Resolve only if the status code is less than 500
                    },
                    headers: {
                    "Content-Type": "application/json"
                    }
                }
                )
                .then(evtResponse => {
                    console.log(evtResponse)
                    this.loading = false;
                    if (evtResponse.data.result === 0){
                        if (evtResponse.data.error === 'Mail not found'){
                            this.loginAlert = true;
                            this.loginAlertMsg = 'La casilla de correo no corresponde con un cliente registrado'
                        }                      
                    }else{
                        this.recoveryform = true
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
            
        },
        async setRecover(){
            if (this.password === ''){
                this.passwordstate = false;
                return;
            }else{
                this.passwordstate = true;
            }

            if (this.recoverycode === ''){
                this.recoverystate = false;
                return;
            }else{
                this.recoverystate = true;
            }

            this.loading = true;
            await axios
                .post(
                this.$store.state.user.siteData.location + "clients/clients/setPassword",
                JSON.stringify({mail: this.name, recoverycode: this.recoverycode, password: this.password}),
                {
                    validateStatus(status) {
                    return status < 500; // Resolve only if the status code is less than 500
                    },
                    headers: {
                    "Content-Type": "application/json"
                    }
                }
                )
                .then(evtResponse => {
                    this.loading = false;
                    console.log(evtResponse)
                    if (evtResponse.data.result === 0){
                        if (evtResponse.data.error === 'Recoverycode invalid'){
                            this.loginAlert = true;
                            this.loginAlertMsg = 'El código de recuperación es incorrecto'
                        }
                    }else{
                        this.$store.dispatch('LogIn',evtResponse.data.data);
                        this.$emit('login', evtResponse.data.data);
                    }
                   
                })
                .catch(()=>{
                    this.loading = false;
                })

        }
    }
}
</script>
